'use strict';

var KEY_BREWING_NOTES = 'cache_brewing_notes',
    KEY_BREWING_NOTES_OPERATIONS = 'cache_brewing_notes_operations',
    KEY_PACKAGING_NOTES = 'cache_packaging_notes',
    KEY_PACKAGING_NOTES_OPERATIONS = 'cache_packaging_notes_operations',
    ChronologycServiceCache,
    {filter} = require('lodash/collection'),
    Constants = require('constants/AppConstants'),
    ContentUtils = require('utils/ContentUtils');

ChronologycServiceCache = {

    /**
     * Add a new or change existing local brewing message.
     * @param message
     */
    addBrewingNote: function (newMessage) {
        if (newMessage) {
            var messageFilter = filter(this.getBrewingNotes(), function (message) {
                return message.date !== newMessage.date;
            });
            messageFilter.push(newMessage);
            this.setBrewingNotes(messageFilter);
            return newMessage;
        }
    },

    /**
     * Add a new or change existing local pacakging message.
     * @param message
     */
    addPackagingNote: function (newMessage) {
        if (newMessage) {
            var messageFilter = filter(this.getPackagingNotes(), function (message) {
                return message.date !== newMessage.date;
            });
            messageFilter.push(newMessage);
            this.setPackagingNotes(messageFilter);
            return newMessage;
        }
    },

    /**
     * Delete given message from local message.
     * @param message
     */
    removeBrewingNote: function (newMessage) {
        if (newMessage) {
            var messageFilter = filter(this.getBrewingNotes(), function (message) {
                return message.date !== newMessage.date;
            });
            this.setBrewingNotes(messageFilter);
        }
    },

    /**
     * Delete given message from local message.
     * @param message
     */
    removePackagingNote: function (newMessage) {
        if (newMessage) {
            var messageFilter = filter(this.getPackagingNotes(), function (message) {
                return message.date !== newMessage.date;
            });
            this.setPackagingNotes(messageFilter);
        }
    },

    /**
     * Retrieve a brewing message by date.
     * @param date
     * @returns {*}
     */
    getBrewingNoteByDate: function (date) {
        return this.getBrewingNotes().filter(function (msg) {
            return msg.date === date;
        })[0];
    },

    /**
     * Retrieve a packaging message by date.
     * @param date
     * @returns {*}
     */
    getPackagingNoteByDate: function (date) {
        return this.getPackagingNotes().filter(function (msg) {
            return msg.date === date;
        })[0];
    },

    /**
     * Add a new brewing operation Note.
     * @param operation
     */
    addBrewingOperation: function (operation) {
        var operations = this.getBrewingOperations();
        operation.indexOperation = operations.length + 1;
        operations.push(operation);
        this.setBrewingOperations(operations);
    },

    /**
     * Add a new packaging operation Note.
     * @param operation
     */
    addPackagingOperation: function (operation) {
        var operations = this.getPackagingOperations();
        operation.indexOperation = operations.length + 1;
        operations.push(operation);
        this.setPackagingOperations(operations);
    },

    /**
     *  Load local cache notes. And then if exist pending operations pending, apply them to actual
     *  local notes.
     * @param {Array} brewingNotes
     */
    fillBrewingNoteCache: function (brewingNotes) {
        this.setBrewingNotes(brewingNotes);
        var self = this,
            pendingOperations = this.getBrewingOperations();

        if (pendingOperations) {
            // If have pending operations, means that after save notas to the server (polling way), during this process,
            // the client did a new notes, that still are pending to save in the next polling save notes.

            //Sort operations in chronologyc way
            (pendingOperations || []).sort(this._prioritizeOperations);

            [].forEach.call(pendingOperations, function (operation) {
                switch (operation.typeOperation) {
                    case  Constants.NOTE_BREWING_OPERATION_NEW:
                        self.addBrewingNote(operation.note);
                        break;
                    case  Constants.NOTE_BREWING_OPERATION_CHANGE:
                        self.addBrewingNote(operation.note);
                        break;
                    case  Constants.NOTE_BREWING_OPERATION_DELETE:
                        self.removeBrewingNote(operation.note);
                        break;
                    default:
                }
            });
        }
    },

    /**
     *  Load local cache notes. And then if exist pending operations pending, apply them to actual
     *  local notes.
     * @param {Array} packagingNotes
     */
    fillPackagingNoteCache: function (packagingNotes) {
        this.setPackagingNotes(packagingNotes);
        var self = this,
            pendingOperations = this.getPackagingOperations();

        if (pendingOperations) {
            // If have pending operations, means that after save notas to the server (polling way), during this process,
            // the client did a new notes, that still are pending to save in the next polling save notes.

            //Sort operations in chronologyc way
            (pendingOperations || []).sort(this._prioritizeOperations);

            [].forEach.call(pendingOperations, function (operation) {
                switch (operation.typeOperation) {
                    case  Constants.NOTE_BREWING_OPERATION_NEW:
                        self.addPackagingNote(operation.note);
                        break;
                    case  Constants.NOTE_BREWING_OPERATION_CHANGE:
                        self.addPackagingNote(operation.note);
                        break;
                    case  Constants.NOTE_BREWING_OPERATION_DELETE:
                        self.removePackagingNote(operation.note);
                        break;
                    default:
                }
            });
        }
    },

    /**
     * Sort operation from index operation number.
     * @argument {Object} operationA
     * @argument {Object} operationB
     * @return {Number}
     */
    _prioritizeOperations: function (operationA, operationB) {
        return operationA.indexOperation - operationB.indexOperation;
    },

    /**
     * Override current brewing local operations for defined by parameter.
     * @param {Array} operations
     */
    setBrewingOperations: function (operations) {
        ContentUtils.saveSession(KEY_BREWING_NOTES_OPERATIONS, operations);
    },

    /**
     * Override current packaging local operations for defined by parameter.
     * @param {Array} operations
     */
    setPackagingOperations: function (operations) {
        ContentUtils.saveSession(KEY_PACKAGING_NOTES_OPERATIONS, operations);
    },

    /**
     * Retrieve all the brewing operations.
     */
    getBrewingOperations: function () {
        var operations = ContentUtils.getSession(KEY_BREWING_NOTES_OPERATIONS);
        return operations === '' ? [] : operations;
    },

    /**
     * Retrieve all the packaging operations.
     */
    getPackagingOperations: function () {
        var operations = ContentUtils.getSession(KEY_PACKAGING_NOTES_OPERATIONS);
        return operations === '' ? [] : operations;
    },

    /**
     * Delete brewing operations performed.
     * @param {Arrays} operationsSaved
     */
    deleteBrewingOperationPerformed: function (operationsSaved) {
        var operations = this.getBrewingOperations(),
            operationUpgraded;
        operationUpgraded = filter(operations, function (operation) {
            var filterOperation = false;
            [].forEach.call(operationsSaved, function (operationSaved) {
                if (operationSaved.indexOperation === operation.indexOperation) {
                    filterOperation = true;
                    return;
                }
            });
            return !filterOperation;
        });
        this.setBrewingOperations(operationUpgraded);
    },

    /**
     * Delete packaging operations performed.
     * @param {Arrays} operationsSaved
     */
    deletePackagingOperationPerformed: function (operationsSaved) {
        var operations = this.getPackagingOperations(),
            operationUpgraded;
        operationUpgraded = filter(operations, function (operation) {
            var filterOperation = false;
            [].forEach.call(operationsSaved, function (operationSaved) {
                if (operationSaved.indexOperation === operation.indexOperation) {
                    filterOperation = true;
                    return;
                }
            });
            return !filterOperation;
        });
        this.setPackagingOperations(operationUpgraded);
    },

    /**
     * Override current brewing local message for defined by parameter.
     * @param messages
     */
    setBrewingNotes: function (messages) {
        ContentUtils.saveSession(KEY_BREWING_NOTES, messages);
    },

    /**
     * Override current packaging local message for defined by parameter.
     * @param messages
     */
    setPackagingNotes: function (messages) {
        ContentUtils.saveSession(KEY_PACKAGING_NOTES, messages);
    },

    /**
     * Retrieve all brewing local message.
     * @returns {*}
     */
    getBrewingNotes: function () {
        var messagesRestore = ContentUtils.getSession(KEY_BREWING_NOTES);
        return messagesRestore === '' ? [] : messagesRestore;
    },

    /**
     * Retrieve all packaging local message.
     * @returns {*}
     */
    getPackagingNotes: function () {
        var messagesRestore = ContentUtils.getSession(KEY_PACKAGING_NOTES);
        return messagesRestore === '' ? [] : messagesRestore;
    }
};


module.exports = ChronologycServiceCache;



/** WEBPACK FOOTER **
 ** ./src/services/ChronologycServiceCache.js
 **/